import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import CropAndSaveImageRequest from "@/api/dataSource/api/Spirit/Common/FileManager/Models/CropAndSaveImageRequest";
import AlbumUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AlbumUpdateRequest";
import AlbumGetDetailReponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MusicService/AlbumGetDetailReponse";
import MusicAudioViewModel from "./musicAudioViewModel";
import MusicTranslateViewModel from "./musicTranslateViewModel";
import MusicAudioTranslationViewModel from "./musicAudioTranslationViewModel";

export default class CreateMusicViewModel {
    id?: number = null;
	isSleep: boolean = false;
	isPaid: boolean = false;
	useOnMainDisplay: boolean = false;
	animationId: string = null;
	animationUrl: string = null;
	audios: Array<MusicAudioViewModel> = [];
	translations: Array<MusicTranslateViewModel> = [];
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	categoriesIds: Array<number> = null;
	toServerModel(): AlbumUpdateRequest {
		const req = new AlbumUpdateRequest({
			Id: this.id,
			IsSleep: this.isSleep,
			IsPaid: this.isPaid,
			UseOnMainDisplay: this.useOnMainDisplay,
			AnimationId: this.animationId,
			Back: this.getCropRequest(this.backgroundImage), // this.coverImage,
			Cover: this.getCropRequest(this.coverImage), // this.coverImage,
			Translations: (this.translations || []).map(x=>x.toServerModel()),
			Audiofiles: (this.audios || []).map(x=>x.toServerModel()),
			Categories: this.categoriesIds,
		});
		// this.audios.forEach(audioGroup => {
		// 	req.Translations.forEach(tr => {
		// 		if (!tr.VoiceFiles) {
		// 			tr.VoiceFiles = [];
		// 		}
		// 		const audios = audioGroup.audios.filter(x=>x.langCode == tr.LangCode);
		// 		if (audios.length > 0) {
		// 			tr.VoiceFiles.push(...(audios.map(a=>a.toServerModel())));
		// 		}
		// 	});
		// });
		return req;
	}
	initLanguages(langs: string[]) {
		this.translations = langs.map(x=>new MusicTranslateViewModel({
			langCode: x
		}));
	}
	getCropRequest(img: ImagePreviewModel): CropAndSaveImageRequest {
		if (!img.Width && !img.Height) {
			return null;
		}
		return new CropAndSaveImageRequest({
			ImgBase: img.ImageUrl,
			Height: parseInt(img.Height.toString()),
			Left: parseInt(img.Left.toString()),
			Top: parseInt(img.Top.toString()),
			Width: parseInt(img.Width.toString())
		});
	}
	fromServerModel(model: AlbumGetDetailReponse) {
		this.id = model.Id;
		this.backgroundImage.ImageUrl = model.BackgroundUrl;
		this.coverImage.ImageUrl = model.CoverUrl;
		this.isPaid = model.IsPaid;
		this.isSleep = model.IsSleep;
		this.animationId = model.AnimationId;
		this.useOnMainDisplay = model.UseOnMainDisplay;
		const langs = this.translations.map(x => x.langCode);
		this.audios = (model.Audiofiles || []).map(x=> new MusicAudioViewModel({
			id: x.Id,
			audioUrl: x.Url,
			translations: langs.map(tr => new MusicAudioTranslationViewModel({
				langCode: tr
			}))
		}));
		
		this.categoriesIds = (model.Categories || []).map(x => x.Id);

		this.translations.forEach(tr => {
			const serverTranslation = model.AlbumTranslations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
			}
		});

		this.audios.forEach((audio) => {
			const serverAudio = model.Audiofiles.find(x=>x.Id == audio.id);
			if (serverAudio != null) {
				audio.translations.forEach(tr => {
					const serverTranslation = serverAudio.AudiofileTranslations.find(f => f.LangCode == tr.langCode);
					if (serverTranslation != null) {
						tr.index = serverTranslation.Index;
						tr.name = serverTranslation.Name;
					}
				})
			}
		});
	}
}
